import { render, staticRenderFns } from "./imageCard.vue?vue&type=template&id=37517372&scoped=true"
import script from "./imageCard.vue?vue&type=script&lang=js"
export * from "./imageCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37517372",
  null
  
)

export default component.exports